// import React from 'react';
// import Navbar from './global-components/navbar';
// import PageHeader from './global-components/page-header';
// import ProductDetails from './shop-components/shop-details';
// import CallToActionV1 from './section-components/call-to-action-v1';
// import Footer from './global-components/footer';
// // import data from "../../data/mainData.json";
// import data from "../../src/data/mainData.json"

// const Product_Details = () => {

//         const pathname = window.location.pathname;
//         console.log('pathname',pathname)

//     const property = data?.propertyDetails?.find(item => item.slug_name === "cheran_nagar_phase_1");
    
//     return <div>
//         <Navbar />
//         <PageHeader 
//             headertitle={property?.title} 
//             customclass="mb-0" 
//             />
//         <ProductDetails />
//         <CallToActionV1 />
//         <Footer />
//     </div>
// }

// export default Product_Details


import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import ProductDetails from './shop-components/shop-details';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';
import data from "../../src/data/mainData.json";

const Product_Details = () => {

    const pathname = window.location.pathname; 

    const slug = pathname.split('/').pop(); 

    // console.log('slug from url:', slug);

    const property = data?.properties?.products?.find(
        item => item.slug_name == slug
    );

    console.log('matched property:', property);

    return (
        <div>
            <Navbar />

            <PageHeader
                headertitle={property?.title || "Property Details"}
                customclass="mb-0"
            />

            {/* You can pass property to details page */}
            <ProductDetails property={property} />

            <CallToActionV1 />
            <Footer />
        </div>
    );
};

export default Product_Details;
